import React from 'react';

const demandPoints = [
  {
    text: '$8.5B+ global market, 14% CAGR',
  },
  {
    text: '155+ U.S. med schools, 700+ residency programs',
  },
  {
    text: 'Shift to AI-based competency evaluation',
  },
  {
    text: 'Rising demand for scalable, data-rich, remote tools',
  },
];

const GrowingDemandSection: React.FC = () => (
  <section id="growing-demand" style={{ background: '#fff', padding: '4rem 0', display: 'flex', justifyContent: 'center' }}>
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      maxWidth: 1300, 
      width: '100%', 
      gap: '3rem', 
      padding: '0 2rem',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '2rem',
        padding: '0 1.5rem'
      }
    }}>
      <div style={{ 
        flex: 1.2,
        '@media (max-width: 768px)': {
          flex: 1,
          width: '100%'
        }
      }}>
        <h2 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 800, 
          marginBottom: '1.5rem', 
          lineHeight: 1.2,
          '@media (max-width: 768px)': {
            fontSize: '2rem',
            textAlign: 'center'
          }
        }}>
          A Growing Demand for Scalable Simulation
        </h2>
        <ul style={{ 
          listStyle: 'none', 
          padding: 0, 
          margin: 0, 
          fontSize: '1.25rem', 
          color: '#222',
          '@media (max-width: 768px)': {
            fontSize: '1.1rem'
          }
        }}>
          {demandPoints.map((point, i) => (
            <li key={i} style={{ marginBottom: '0.75rem' }}>
              {point.text}
            </li>
          ))}
        </ul>
      </div>
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        '@media (max-width: 768px)': {
          width: '100%'
        }
      }}>
        <img 
          src="/silomedai-assets/images/market-growth-chart.png" 
          alt="Global Medical Simulation Market Growth Chart" 
          style={{ 
            maxWidth: '100%', 
            height: 'auto', 
            borderRadius: '3px', 
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
          }} 
        />
      </div>
    </div>
  </section>
);

export default GrowingDemandSection; 